export default "__VITE_ASSET__CYpVeLCI__"